import { type CaseReducer, type PayloadAction } from '@reduxjs/toolkit';

import { type Credentials, type SessionState } from '../types';

const setSessionCase: CaseReducer<SessionState, PayloadAction<Credentials>> = (
  state,
  action,
) => {
  const credentials = action.payload;
  state.status = 'logged';
  state.credentials = credentials;
};

export { setSessionCase };
